export default __webpack_public_path__ + "images/select-ivr.svg";